import { render, staticRenderFns } from "./appTestNav.vue?vue&type=template&id=6be8ece6&scoped=true&"
import script from "./appTestNav.vue?vue&type=script&lang=js&"
export * from "./appTestNav.vue?vue&type=script&lang=js&"
import style0 from "./appTestNav.vue?vue&type=style&index=0&id=6be8ece6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8ece6",
  null
  
)

export default component.exports